var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-primary",attrs:{"dark":""},on:{"click":_vm.acceptPayOutsidePlatform}},[_c('div',{staticClass:"text-btn"},[_vm._v(" "+_vm._s(_vm.$t('chat.ButtonAcceptPaymentOutsidePlatform'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }